export { default as RoofingShingles } from './RoofingShingles';
export { SHINGLES_COUNT } from './RoofingShingles';
